export const LIST_ITEM_HEADER = 'ListItemHeader';
export const LIST_ITEM_BODY = 'ListItemBody';
